module.exports = __webpack_public_path__ + "assets/img/hcpbt2.4b55ca70.png";